var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Polaris-ColorPicker"
  }, [_c('div', {
    ref: "palette",
    staticClass: "Polaris-ColorPicker__MainColor"
  }, [_c('div', {
    staticClass: "Polaris-ColorPicker__ColorLayer",
    style: (_vm.colorLayerStyle)
  }), _vm._v(" "), _c('polaris-color-picker-slidable', {
    attrs: {
      "dragger-x": _vm.draggerX,
      "dragger-y": _vm.draggerY
    },
    on: {
      "change": _vm.handleDraggerMove
    }
  })], 1), _vm._v(" "), _c('polaris-color-picker-hue-picker', {
    attrs: {
      "hue": _vm.color.hue
    },
    on: {
      "change": _vm.handleHueChange
    }
  }), _vm._v(" "), (_vm.allowAlpha) ? _c('polaris-color-picker-alpha-picker', {
    attrs: {
      "alpha": _vm.color.alpha
    },
    on: {
      "change": _vm.handleAlphaChange
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8efe0d7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8efe0d7c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisColorPicker.vue
// module id = 264
// module chunks = 0